<template>
  <div class="grid items-center justify-center h-screen bg-gray-900">
    <div class="flex justify-center">
      <div class="w-full max-w-sm mx-auto">
        <div class="card">
          <div class="p-6">
            <div class="px-4 py-2 mb-3 text-red-700 bg-red-200 rounded-md" v-if="errors.length">
              <div v-for="error in errors" :key="error.message">
                {{ error.message }}
              </div>
            </div>
            <form @submit.prevent="unlock()" :disabled="submitting">
              <fieldset class="form-group">
                <input id="access_code" class="text-center form-input" :type="showCode ? 'text' : 'password'" tabindex="2" placeholder="Access Code" v-model="form.access_code" required>
              </fieldset>
              <button type="submit" class="w-full btn btn-lg btn-primary" v-submitting="submitting">
                Enter
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MonitorLock',
  
  data () {
    return {
      errors: [],
      submitting: false,
      showCode: false,
      form: {
        access_code: ''
      }
    }
  },

  methods: {
    async unlock () {
      try {
        this.submitting = true
        const { data } = await this.$api.post(`account/${this.$route.params.account}/monitor/unlock`, this.form)
        if (data === true) {
          this.$router.push({ name: 'MonitorMap' })
        } else {
          this.$toasted.error('Incorrect access code.')
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>